import React from 'react';
import TeamSection from '../TeamSection/TeamSection';
import MatchCta from '../MatchCta/MatchCta';

function MatchupRow({
  homeAbbreviation,
  homeLogoUrl,
  homeBackgroundColor,
  homeGoals,
  awayAbbreviation,
  awayLogoUrl,
  awayBackgroundColor,
  awayGoals,
  showScore,
  matchStatus,
  appleStreamURL,
  hasHighlights,
  highlightsUrl,
  matchPageUrl,
  slug,
  position,
  matchId,
  location,
  sponsor,
}) {
  return (
    <div className="mls-c-priority-match__matchup-row">
      <TeamSection
        abbreviation={homeAbbreviation}
        logoUrl={homeLogoUrl}
        backgroundColor={homeBackgroundColor}
        score={homeGoals}
        showScore={showScore}
      />
      <MatchCta
        matchStatus={matchStatus}
        appleStreamURL={appleStreamURL}
        hasHighlights={hasHighlights}
        highlightsUrl={highlightsUrl}
        matchPageUrl={matchPageUrl}
        slug={slug}
        position={position}
        matchId={matchId}
        location={location}
        sponsor={sponsor}
      />
      <TeamSection
        abbreviation={awayAbbreviation}
        logoUrl={awayLogoUrl}
        backgroundColor={awayBackgroundColor}
        score={awayGoals}
        showScore={showScore}
        reverse
      />
    </div>
  );
}

export default MatchupRow;
